// extracted by mini-css-extract-plugin
export default {"box":"viewer-handler_box__km45A","viewerShimmer":"viewer-handler_viewerShimmer__nrPGe","loading":"viewer-handler_loading__y459A","empty":"viewer-handler_empty__WXChx"};